import React from 'react';

const TeamWorkflowSVG = ({ compact = false, context = 'default' }) => {
  const width = compact ? 650 : 1050;
  const height = compact ? 470 : 650;
  
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      margin: '18px 10px'
    }}>
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ 
        maxWidth: '100%', 
        height: 'auto'
      }}>
        <defs>
          {/* Background gradient to match home.js */}
          <linearGradient id="bgGradientTeam" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#f0f9ff" />
            <stop offset="100%" stopColor="#e0f2fe" />
          </linearGradient>
          
          {/* Gradients */}
          <linearGradient id="agentGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3b82f6" />
            <stop offset="100%" stopColor="#1d4ed8" />
          </linearGradient>
          <linearGradient id="memberGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#8b5cf6" />
            <stop offset="100%" stopColor="#7c3aed" />
          </linearGradient>
          <linearGradient id="smartcloseGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#10b981" />
            <stop offset="100%" stopColor="#059669" />
          </linearGradient>
          <linearGradient id="notificationGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#f59e0b" />
            <stop offset="100%" stopColor="#d97706" />
          </linearGradient>
          
          {/* Pulse effect for notifications */}
          <filter id="pulse">
            <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
            <feMerge> 
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
          
          {/* Circle clip for agent image */}
          <clipPath id="agentClip">
            <circle cx="0" cy="0" r={compact ? "30" : "40"} />
          </clipPath>
          
          {/* Circle clip for team member image */}
          <clipPath id="memberClip">
            <circle cx="0" cy="0" r="45" />
          </clipPath>
          
          {/* Additional clip for ensuring roundness */}
          <clipPath id="agentClipRound">
            <circle cx="0" cy="0" r="40" />
          </clipPath>
          
          {/* Circle clip for brokerage image */}
          <clipPath id="brokerageClip">
            <circle cx="0" cy="0" r="45" />
          </clipPath>
          
          {/* Circle clip for smaller dual images */}
          <clipPath id="smallClip">
            <circle cx="0" cy="0" r="32" />
          </clipPath>
        </defs>
        
        {/* Background */}
        <rect width={width} height={height} fill="url(#bgGradientTeam)" rx="16" />
        
        {/* Title */}
        <text x={width/2} y="40" textAnchor="middle" fontSize={compact ? "18" : "23"} fontWeight="700" fill="#3b82f6">
          🧭 Smart Team Workflow
        </text>
        
        {/* Scenario 1: Agent/Admin Sends Documents */}
        <g transform={`translate(${compact ? 50 : 90}, ${compact ? 70 : 95})`}>
          <text x="0" y="-8" fontSize={compact ? "16" : "17"} fontWeight="600" fill="#041024ff">
            ✅ Team Admin/Agent sends documents → All team members notified
          </text>
          
          {/* Agent/Admin */}
          <g transform={`translate(${compact ? "10" : "45"}, ${compact ? "20" : "30"})`}>
            <circle cx="90" cy="30" r="45" fill="#3b82f6" />
            <g transform={`translate(${compact ? "90" : "90"}, ${compact ? "30" : "30"})`}>
              <image href="/agent_female.jpg" 
                     x={compact ? "-40" : "-40"} 
                     y={compact ? "-40" : "-40"} 
                     width={compact ? "80" : "80"} 
                     height={compact ? "80" : "80"} 
                     clipPath="url(#agentClipRound)" />
            </g>
            <text x="90" y="90" textAnchor="middle" 
                  fontSize={compact ? "13" : "14"} fontWeight="600" fill="#3b82f6">Team Admin</text>
          </g>
          
          {/* Arrow to SmartClose - always visible with flowing animation */}
          <path d={`M ${compact ? 145 : 185} ${compact ? 50 : 60} L ${compact ? 255 : 345} ${compact ? 50 : 60}`} 
                stroke="#3b82f6" strokeWidth={compact ? "6" : "8"} fill="none" 
                strokeDasharray="12,6">
            <animate attributeName="stroke-dashoffset" values="18;0" dur="3s" repeatCount="indefinite" />
          </path>
          
          {/* Animated document icons flowing */}
          <text fontSize={compact ? "32" : "42"} fill="#3b82f6">
            <animateMotion dur="3s" repeatCount="indefinite"
                           path={`M ${compact ? 145 : 185} ${compact ? 50 : 60} L ${compact ? 255 : 345} ${compact ? 50 : 60}`}>
            </animateMotion>
            📧
          </text>
          
          {/* SmartClose AI */}
          <g transform={`translate(${compact ? 240 : 330}, 20)`}>
            {/* AI Brain with Real Estate Intelligence */}
            <circle cx={compact ? "50" : "60"} cy={compact ? "30" : "40"} r={compact ? "35" : "45"} fill="url(#smartcloseGradient)" opacity="0.15" />
            <circle cx={compact ? "50" : "60"} cy={compact ? "30" : "40"} r={compact ? "30" : "40"} fill="url(#smartcloseGradient)" />
            
            {/* SmartClose Logo */}
            <rect x={compact ? "25" : "30"} y={compact ? "18" : "22"} width={compact ? "50" : "60"} height={compact ? "24" : "35"} fill="white" rx="5" />
            <text x={compact ? "50" : "60"} y={compact ? "27" : "35"} textAnchor="middle" fontSize={compact ? "11" : "14"} fontWeight="700" fill="#2563eb">Smart</text>
            <text x={compact ? "50" : "60"} y={compact ? "37" : "50"} textAnchor="middle" fontSize={compact ? "11" : "14"} fontWeight="700" fill="#2563eb">Team</text>
            
            {/* AI Processing indicators */}
            <g opacity="0.9">
              <circle cx={compact ? "25" : "35"} cy={compact ? "15" : "20"} r={compact ? "2" : "3"} fill="#60a5fa">
                <animate attributeName="cy" values={`${compact ? "15;22;15" : "20;27;20"}`} dur="2s" repeatCount="indefinite" />
              </circle>
              <circle cx={compact ? "75" : "85"} cy={compact ? "18" : "23"} r={compact ? "2" : "3"} fill="#34d399">
                <animate attributeName="cy" values={`${compact ? "18;25;18" : "23;30;23"}`} dur="1.8s" repeatCount="indefinite" />
              </circle>
              <circle cx={compact ? "35" : "45"} cy={compact ? "45" : "55"} r={compact ? "2" : "3"} fill="#fbbf24">
                <animate attributeName="cy" values={`${compact ? "45;38;45" : "55;48;55"}`} dur="2.2s" repeatCount="indefinite" />
              </circle>
              <circle cx={compact ? "65" : "75"} cy={compact ? "12" : "17"} r={compact ? "2" : "3"} fill="#f87171">
                <animate attributeName="cy" values={`${compact ? "12;19;12" : "17;24;17"}`} dur="1.6s" repeatCount="indefinite" />
              </circle>
            </g>
          </g>
          
          {/* Arrow from SmartClose AI to Calendar */}
          <path d={`M ${compact ? 290 : 390} ${compact ? 70 : 100} L ${compact ? 290 : 390} ${compact ? 120 : 150}`} 
                stroke="#10b981" strokeWidth={compact ? "4" : "6"} fill="none" 
                strokeDasharray="8,4">
            <animate attributeName="stroke-dashoffset" values="12;0;-12;0" dur="4s" repeatCount="indefinite" />
          </path>
          
          <path id="calendarPath1" d={`M ${compact ? 290 : 390} ${compact ? 70 : 100} L ${compact ? 290 : 390} ${compact ? 120 : 150}`} fill="none" />
          
          {/* Arrow to All Team Members - always visible with flowing animation */}
          <path d={`M ${compact ? 320 : 440} ${compact ? 50 : 60} L ${compact ? 435 : 575} ${compact ? 50 : 60}`} 
                stroke="#3b82f6" strokeWidth={compact ? "6" : "8"} fill="none" 
                strokeDasharray="12,6">
            <animate attributeName="stroke-dashoffset" values="18;0" dur="3.2s" repeatCount="indefinite" />
          </path>
          
          {/* Animated notification icons flowing */}
          <text fontSize={compact ? "25" : "32"} fill="#10b981" textAnchor="middle" dominantBaseline="middle">
            <animateMotion dur="3.2s" repeatCount="indefinite" 
                           path={`M ${compact ? 320 : 440} ${compact ? 40 : 50} L ${compact ? 435 : 575} ${compact ? 40 : 50}`}>
            </animateMotion>
            📅
          </text>
          
          {/* All Team Members */}
          <g transform={`translate(${compact ? 420 : 560}, 20)`}>
            <circle cx="75" cy="30" r="50" fill="#f59e0b" />
            <g transform={`translate(${compact ? "75" : "75"}, ${compact ? "30" : "30"})`}>
              <image href="/brokerage.jpg" 
                     x={compact ? "-45" : "-45"} 
                     y={compact ? "-45" : "-45"} 
                     width={compact ? "90" : "90"} 
                     height={compact ? "90" : "90"} 
                     clipPath="url(#brokerageClip)" />
            </g>
            <text x="75" y="95" textAnchor="middle" 
                  fontSize={compact ? "13" : "14"} fontWeight="600" fill="#3b82f6">Everyone on the Team</text>
          </g>
        </g>
        
        {/* Central Shared Calendar */}
        <g transform={`translate(${compact ? 55 : 75}, ${compact ? 155 : 210})`}>
          <rect x={compact ? "175" : "300"} y="18" width="220" height="130" fill="white" stroke="#2563eb" strokeWidth="4" rx="12" />
          <text x={compact ? "285" : "410"} y="42" textAnchor="middle" fontSize="15" fontWeight="600" fill="#1e40af">Smart AI Calendar & Task Hub</text>
          
          {/* Calendar with Real Estate Events */}
          <rect x={compact ? "195" : "320"} y="50" width="180" height="88" fill="#f8fafc" stroke="#cbd5e1" strokeWidth="2" rx="8" />
          
          {/* Property-specific color coding */}
          <rect x={compact ? "205" : "330"} y="60" width="50" height="18" fill="#ef4444" rx="3" />
          <text x={compact ? "225" : "355"} y="72" textAnchor="middle" fontSize="12" fill="white">123 Oak</text>
          
          <rect x={compact ? "255" : "385"} y="60" width="50" height="18" fill="#3b82f6" rx="3" />
          <text x={compact ? "275" : "410"} y="72" textAnchor="middle" fontSize="12" fill="white">456 Elm</text>
          
          <rect x={compact ? "305" : "440"} y="60" width="55" height="18" fill="#10b981" rx="3" />
          <text x={compact ? "330" : "465"} y="72" textAnchor="middle" fontSize="12" fill="white">789 Pine</text>
          
          <rect x={compact ? "205" : "330"} y="85" width="60" height="18" fill="#f59e0b" rx="3" />
          <text x={compact ? "232" : "359"} y="97" textAnchor="middle" fontSize="12" fill="white">Inspection</text>
          
          <rect x={compact ? "270" : "395"} y="85" width="60" height="18" fill="#8b5cf6" rx="3" />
          <text x={compact ? "297" : "422"} y="97" textAnchor="middle" fontSize="12" fill="white">Closing</text>
          
          <rect x={compact ? "205" : "330"} y="110" width="128" height="18" fill="#ec4899" rx="3" />
          <text x={compact ? "265" : "390"} y="122" textAnchor="middle" fontSize="12" fill="white">Multi-Property Review</text>
        </g>
        
        {/* Scenario 2: Team Member Sends Documents */}
        <g transform={`translate(${compact ? 50 : 90}, ${compact ? 345 : 400})`}>
          <text x="0" y="-8" fontSize={compact ? "16" : "17"} fontWeight="600" fill="#041024ff">
            ✅ Team Member sends documents → Member & Admin notified
          </text>
          
          {/* Team Member */}
          <g transform={`translate(${compact ? "10" : "45"}, ${compact ? "20" : "30"})`}>
            <circle cx="90" cy="30" r="45" fill="#8b5cf6" />
            <g transform={`translate(${compact ? "80" : "90"}, ${compact ? "30" : "30"})`}>
              <image href="/assistant.png" 
                     x={compact ? "-35" : "-45"} 
                     y={compact ? "-45" : "-45"} 
                     width={compact ? "90" : "90"} 
                     height={compact ? "90" : "90"} 
                     clipPath="url(#memberClip)" />
            </g>
            <text x="90" y="90" textAnchor="middle" 
                  fontSize={compact ? "13" : "14"} fontWeight="600" fill="#8b5cf6">Team Member</text>
          </g>
          
          {/* Arrow to SmartClose - always visible with flowing animation */}
          <path d={`M ${compact ? 145 : 185} ${compact ? 50 : 60} L ${compact ? 255 : 345} ${compact ? 50 : 60}`} 
                stroke="#8b5cf6" strokeWidth={compact ? "6" : "8"} fill="none" 
                strokeDasharray="12,6">
            <animate attributeName="stroke-dashoffset" values="18;0" dur="3.5s" repeatCount="indefinite" />
          </path>
          
          {/* Animated document icons flowing */}
          <text fontSize={compact ? "32" : "42"} fill="#8b5cf6">
            <animateMotion dur="3s" repeatCount="indefinite"
                           path={`M ${compact ? 145 : 185} ${compact ? 50 : 60} L ${compact ? 255 : 345} ${compact ? 50 : 60}`}>
            </animateMotion>
            📧
          </text>
          
          {/* SmartClose AI */}
          <g transform={`translate(${compact ? 240 : 330}, 20)`}>
            {/* AI Brain with Real Estate Intelligence */}
            <circle cx={compact ? "50" : "60"} cy={compact ? "30" : "40"} r={compact ? "35" : "45"} fill="url(#smartcloseGradient)" opacity="0.15" />
            <circle cx={compact ? "50" : "60"} cy={compact ? "30" : "40"} r={compact ? "30" : "40"} fill="url(#smartcloseGradient)" />
            
            {/* SmartClose Logo */}
            <rect x={compact ? "25" : "30"} y={compact ? "18" : "22"} width={compact ? "50" : "60"} height={compact ? "24" : "35"} fill="white" rx="5" />
            <text x={compact ? "50" : "60"} y={compact ? "27" : "35"} textAnchor="middle" fontSize={compact ? "11" : "14"} fontWeight="700" fill="#2563eb">Smart</text>
            <text x={compact ? "50" : "60"} y={compact ? "37" : "50"} textAnchor="middle" fontSize={compact ? "11" : "14"} fontWeight="700" fill="#2563eb">Team</text>

            {/* AI Processing indicators */}
            <g opacity="0.9">
              <circle cx={compact ? "25" : "35"} cy={compact ? "15" : "20"} r={compact ? "2" : "3"} fill="#60a5fa">
                <animate attributeName="cy" values={`${compact ? "15;22;15" : "20;27;20"}`} dur="2s" repeatCount="indefinite" />
              </circle>
              <circle cx={compact ? "75" : "85"} cy={compact ? "18" : "23"} r={compact ? "2" : "3"} fill="#34d399">
                <animate attributeName="cy" values={`${compact ? "18;25;18" : "23;30;23"}`} dur="1.8s" repeatCount="indefinite" />
              </circle>
              <circle cx={compact ? "35" : "45"} cy={compact ? "45" : "55"} r={compact ? "2" : "3"} fill="#fbbf24">
                <animate attributeName="cy" values={`${compact ? "45;38;45" : "55;48;55"}`} dur="2.2s" repeatCount="indefinite" />
              </circle>
              <circle cx={compact ? "65" : "75"} cy={compact ? "12" : "17"} r={compact ? "2" : "3"} fill="#f87171">
                <animate attributeName="cy" values={`${compact ? "12;19;12" : "17;24;17"}`} dur="1.6s" repeatCount="indefinite" />
              </circle>
            </g>
          </g>
          
          {/* Arrow from SmartClose AI to Calendar */}
          <path d={`M ${compact ? 290 : 390} ${compact ? 25 : 20} L ${compact ? 290 : 390} ${compact ? -35 : -45}`} 
                stroke="#10b981" strokeWidth={compact ? "4" : "6"} fill="none" 
                strokeDasharray="8,4">
            <animate attributeName="stroke-dashoffset" values="12;0;-12;0" dur="4s" repeatCount="indefinite" />
          </path>
          
          <path id="calendarPath2" d={`M ${compact ? 290 : 390} ${compact ? 70 : 20} L ${compact ? 290 : 390} ${compact ? 10 : -45}`} fill="none" />
          
          {/* Arrow to Member + Agent - always visible with flowing animation */}
          <path d={`M ${compact ? 320 : 440} ${compact ? 50 : 60} L ${compact ? 435 : 575} ${compact ? 50 : 60}`} 
                stroke="#8b5cf6" strokeWidth={compact ? "6" : "8"} fill="none" 
                strokeDasharray="12,6">
            <animate attributeName="stroke-dashoffset" values="18;0" dur="3.8s" repeatCount="indefinite" />
          </path>
          
          {/* Animated notification icons flowing */}
          <text fontSize={compact ? "25" : "32"} fill="#10b981" textAnchor="middle" dominantBaseline="middle">
            <animateMotion dur="3.2s" repeatCount="indefinite"
                           path={`M ${compact ? 320 : 440} ${compact ? 40 : 50} L ${compact ? 435 : 575} ${compact ? 40 : 50}`}>
            </animateMotion>
            📅
          </text>
          
          {/* Member + Agent/Admin */}
          <g transform={`translate(${compact ? 420 : 560}, 20)`}>
            <circle cx="45" cy="30" r="35" fill="#8b5cf6" />
            <circle cx="105" cy="30" r="35" fill="#3b82f6" />
            <g transform={`translate(${compact ? "45" : "45"}, ${compact ? "30" : "30"})`}>
              <image href="/assistant.png" 
                     x={compact ? "-32" : "-35"} 
                     y={compact ? "-32" : "-35"} 
                     width={compact ? "64" : "70"} 
                     height={compact ? "64" : "70"} 
                     clipPath="url(#smallClip)" />
            </g>
            <g transform={`translate(${compact ? "105" : "105"}, ${compact ? "30" : "30"})`}>
              <image href="/agent_female.jpg" 
                     x={compact ? "-32" : "-32"} 
                     y={compact ? "-32" : "-32"} 
                     width={compact ? "64" : "64"} 
                     height={compact ? "64" : "64"} 
                     clipPath="url(#smallClip)" />
            </g>
            <text x="75" y="85" textAnchor="middle" 
                  fontSize={compact ? "13" : "14"} fontWeight="600" fill="#8b5cf6">Member+Admin</text>
          </g>
        </g>
        
        {/* Legend/Key */}
        {!compact && (
          <g transform="translate(40, 550)">
            <text x="0" y="0" fontSize="16" fontWeight="600" fill="#2563eb">📚 Key Benefits for Your Team:</text>
            <line x1="0" y1="6" x2="230" y2="6" stroke="#2563eb" strokeWidth="3" />
            <text x="20" y="26" fontSize="15" fill="#059669">✅ Smart Task & Calendar Routing — Tasks auto-assign by sender role, keeping the right people informed and accountable.</text>
            <text x="20" y="46" fontSize="15" fill="#0369a1">📅 Context-Aware Calendar Sync — Only relevant team members receive calendar updates.</text>
            <text x="20" y="66" fontSize="15" fill="#7c2d12">👥 Admin Oversight — Admins have complete visibility into all team activity, ensuring nothing is missed.</text>
            <text x="20" y="86" fontSize="15" fill="#6b21a8">⚡ Multi-Calendar Sync — Automatically syncs events across Google, Outlook, and Apple — only for the parties involved.</text>
          </g>
        )}
      </svg>
    </div>
  );
};

export default TeamWorkflowSVG;